
<template>
  <div class="question">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">

      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/homePage'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          待解决问题
        </a-breadcrumb-item>
      </a-breadcrumb>

<!--      <span class="icon"-->
<!--            @click="goHistory"><img class="goHistory"-->
<!--             src="../../assets/image/08.png"-->
<!--             alt=""></span>-->
<!--      <span class="iconText">待解决问题</span>-->
      <router-link :to="{name: 'QuestionAchived'}">
        <div class="button">已解决问题</div>
      </router-link>
    </div>
    <div class="content">
      <div class="contMes">
        <div class="mesTop">
          <a-row>
            <a-col :span="6">
              <a-select default-value="全部文章"
                        style="width: 260px"
                        @change="handleBook">
                <a-select-option :value="item.id"
                                 v-for="(item, index) in bookList"
                                 :key="index">
                  {{item.orgDisplayName}}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="15">
              <a-select default-value="全部班级"
                        style="width: 160px"
                        @change="handleClass">
                <a-select-option :value="item.id"
                                 v-for="(item, index) in classList"
                                 :key="index">
                  {{item.className}}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="3"
                   style="margin-left:auto;">
              <router-link :to="{name: 'QuestionToSolve',params:{show:2}}">
                <div class="questionSolve">问题处理</div>
              </router-link>
            </a-col>
          </a-row>
        </div>
        <div class="mesList">
          <a-list item-layout="vertical"
                  style="min-height: 500px"
                  size="large"
                  :data-source="listData">
            <a-list-item slot="renderItem"
                         key="item.title"
                         slot-scope="item">
              <a-list-item-meta :description="item.description">
                <div slot="title">
                  <div class="prepare">
                    <div class="bookName">{{item.lessonTitle}}</div>
                    <p class="bookTitle">{{item.textContent}}</p>
                    <a-row>
                      <a-col :span="1">
                       <img class="photoImg"
                             v-if="item.userPhoto&&item.userPhoto!=null"
                             :src="$userINfoBasePath+'/'+item.userPhoto"
                             alt="" />
                        <img class="photoImg"
                             v-if="!item.userPhoto||item.userPhoto == null"
                             src="../../assets/imgs/student.png"
                             alt="" />
                      </a-col>
                      <a-col :span="23">
                        <span class="userName">{{item.userName}}</span><span class="userSchool">{{item.userClassInfo}}</span>
                        <p class="questionText">{{item.content}}</p>
                        <p class="date">{{format.formatDayTime(item.createDate)}}</p>
                        <div v-for="(t,index) in item.replyList.slice(0,1)"
                             :key="'child'+index">
                          <img class="photoImg"
                               v-if="!t.userPhoto||t.userPhoto==null"
                               src="../../assets/imgs/student.png"
                               alt="" />
                          <img class="photoImg"
                               v-if="t.userPhoto"
                               :src="$userINfoBasePath+'/'+t.userPhoto"
                               alt="" />
                          <span class="userName">{{t.userName}}</span>
                          <span class="fuhao">@</span>
                          <span class="userSchool">{{t.recuserName}}</span>
                          <p class="questionText">{{t.replyContent}}</p>
                          <p class="date">{{format.formatDayTime(t.createDate)}}</p>
                        </div>
                        <div class="forAsk"
                             @click="goLookAsk(item.id)"> 查看全部回答 </div>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="askHelp">
                    <a-button class="help"
                              @click="askForProfession(item)">求助专家</a-button>
                    <a-button class="ask"
                              @click="answer(item)">回答</a-button>
                  </div>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
          <div style="text-align:center;background: #FFFFFF;padding-top: 20px">
            <a-config-provider>
              <a-pagination :default-current="1"
                            :page-size="pageSize"
                            @change="handleListChange"
                            :total='total' />
            </a-config-provider>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="lookMore"
             width="1100px"
             title="查看全部回答"
             footer="">
      <div class="mesMore">
        <div slot="title">
          <div class="prepare">
            <div class="bookName">{{allAnswer.lessonTitle}}</div>
            <p class="bookTitle">{{allAnswer.textContent}}</p>
            <a-row>
              <a-col :span="1">
                <img class="photoImg"
                     v-if="!allAnswer.userPhoto"
                     src="../../assets/imgs/student.png"
                     alt="" />
                <img class="photoImg"
                     v-if="allAnswer.userPhoto&&allAnswer.userPhoto!=null"
                     :src="$userINfoBasePath+'/'+allAnswer.userPhoto"
                     alt="" />
              </a-col>
              <a-col :span="23">
                <span class="userName">{{allAnswer.userName}}</span>
                <span class="userSchool">{{allAnswer.userClassInfo}}</span>
                <p class="questionText">{{allAnswer.content}}</p>
                <p class="date">{{format.formatDayTime(allAnswer.createDate)}}</p>
                <div v-for="(t,index) in allAnswer.replyList"
                     :key="'child'+index">
                  <img class="photoImg"
                       v-if="t.userPhoto"
                       :src="$userINfoBasePath+'/'+t.userPhoto"
                       alt="" />
                  <span class="userName">{{t.userName}}</span>
                  <span class="fuhao">@</span><span class="userSchool">{{t.recuserName}}</span>
                  <p class="questionText">{{t.replyContent}}</p>
                  <p class="date">{{format.formatDayTime(t.createDate)}}</p>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="askHelp">
        <a-button class="help"
                  @click="askForProfession(allAnswer)">求助专家</a-button>
        <a-button class="ask"
                  @click="answer(allAnswer)">回答</a-button>
      </div>
    </a-modal>
    <!--回答弹窗-->
    <a-modal v-model="answerModal"
             style="z-index:99999;"
             width="1100px"
             title=""
             footer="">
      <div class="answerMes">
        <div><span class="answerText">回答</span><span class="answerName">{{askMess.userName}}</span></div>
        <div class="answerTitle">{{askMess.askContent}}</div>
        <div class="answerBgc">
          <a-textarea v-model="value"
                      :auto-size="{ minRows: 6, maxRows: 10 }" />
        </div>
      </div>
      <div class="askHelp">
        <a-button class="ask"
                  @click="teacherReplay(askMess)">确定</a-button>
      </div>
    </a-modal>
    <!--求助专家-->
    <a-modal v-model="zhuanjiaModal"
             width="576px"
             title=""
             footer="">
      <div class="zjcontent">
        <div class="title">求助专家</div>
        <div class="proplem">是否确定求助专家解答 <span class="name">{{expertName}}</span> 的问题</div>
        <div class="zjFooter">
          <a-button class="cancle"
                    @click="zhuanjiaModal=false">取消</a-button>
          <a-button class="sure"
                    @click="askSure">确认</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import format from '../../utils/format.js'
export default {
  name: 'QuestionSolve',
  data () {
    return {
      format,
      resBasePath: this.$resBasePath,
      lookMore: false,
      answerModal: false,
      zhuanjiaModal: false,
      loading: false,
      value: '', // 回复人内容
      allAnswer: '', // 产看全部回答详情
      askMess: '',
      userName: '', // 回复某个人姓名
      expertName: '',
      value: '', // 文本输入
      bookList: [], // 文章列表
      styleId: '', // 文章选择
      classList: [], // 班级列表
      classId: '', // 班级选择
      listData: [], // 问题列表
      current: 0, // 当前页数
      total: 0, // 总页数
      pageSize: 10,
      pageNum: 1,
      listData: [],
      askParam: { // 求助专家参数
        id: '', // 问题ID
        userId: '', // 用户ID
        bookId: ''
      }
    }
  },
  methods: {
    goHistory () {
      this.$router.go(-1)
    },
    goLookAsk (id) {
      this.lookMore = true
      // this.allAnswer = item
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getAskReplyPageByAskId',
        body: { id: id }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.allAnswer = res.resultData
        }
      })
    },
    askForProfession (item) {
      // console.log(item)
      this.zhuanjiaModal = true
      this.expertName = item.userName
      this.askParam = { // 求助专家参数
        id: item.id, // 问题ID
        userId: this.$getUserInfo().id, // 用户ID
        bookId: localStorage.getItem('syzg-bookId')
      }
    },
    handleBook (val) {
      this.styleId = val
      this.getQuestionList()
    },
    answer (ans) {
      this.answerModal = true
      this.askMess = ans
    },
    handleClass (val) {
      this.classId = val
      this.getQuestionList()
    },
    getBookLessonList () {
      if (localStorage.getItem('syzg-bookId') == null || localStorage.getItem('syzg-bookId') == '' || localStorage.getItem('syzg-bookId') == 'undefined') {
        this.bookId = 1
      } else {
        this.bookId = localStorage.getItem('syzg-bookId')
      }
      // var bookId = localStorage.getItem('syzg-bookId')
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getBookLessonList',
        body: { bookId: this.bookId }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.bookList = res.resultData
        }
      })
    },
    getClassList () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getTeacherClassList',
        body: { userId: this.$getUserInfo().id }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.classList = res.resultData
        }
      })
    },
    getQuestionList () {
      const param = {
        userId: this.$getUserInfo().id,
        styleId: this.styleId,
        classId: this.classId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/ask/getTeacherToBeSolve',
        body: param
      }).loading(
        () => (_this.loading = true),
        () => (_this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.listData = res.resultData.list
          _this.total = res.resultData.total
        }
      })
    },
    teacherReplay (askMess) { // ebook/comment/teacherReplyAsk
      // console.log(askMess)
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        userId: this.$getUserInfo().id, // 用户id
        bookId: bookId, // 书id
        styleId: askMess.styleId, // 课id
        recuserId: askMess.userId, // 被回复人id
        replyContent: this.value, // 回复内容
        rootId: askMess.id, // 问题id
        parentId: askMess.id// 上级id
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/saveTeacherReply',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('回复成功')
          this.answerModal = false
          this.lookMore = false
          this.getQuestionList()
          this.value = ''
        }
      })
    },
    askSure () { // 求助专家
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/pushExpert',
        body: this.askParam
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('已求助')
          this.zhuanjiaModal = false
        }
      })
    },
    handleListChange (current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getQuestionList()
    }
  },
  mounted () {
    this.getBookLessonList()
    this.getClassList()
    this.getQuestionList()
  }
}
</script>
<style lang="less" scoped>
ul,
li,
p {
  margin: 0;
  padding: 0;
  list-style: none;
}
.question {
  position: relative;
  min-width: 1024px;
  max-width: 1680px;
  margin: 0 auto;

  .load {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .top {
    //height: 110px;
    //background-color: #fff;
    position: relative;
    padding: 0 30px;

    .breadcrumb{
      margin: 20px auto ;
      //width: 1200px;
    }

    .goHistory {
      width: 16px;
      height: 32px;
      cursor: pointer;
    }
    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }
    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 100px;
      color: #9d9292;
      font-size: 24px;
    }
    .button {
      position: absolute;
      width: 130px;
      height: 35px;
      background-color: @primary-color;
      text-align: center;
      line-height: 35px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #FFFFFF;
      border-radius: 20px;
      top: 50%;
      right: 40px;
      margin-top: -20px;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    background: #f6f6f6;
    border-radius: 8px;

    .contMes {
      //width: 1240px;
      background: #fff;
      margin: 0 auto;
      padding: 20px 30px;
      border-radius: 8px;

      .questionSolve {
        text-align: right;
        width: 120px;
        height: 32px;
        background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
        box-shadow: 0px 2px 8px 0px #dbcebc;
        border-radius: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        margin-left: auto;
      }
    }
    .mesList {
      //width: 1140px;
      margin: 0 auto;
      background: #f6f6f6;
      margin-top: 20px;
      border-radius: 8px;

    }
  }
}
// 查看全部回答公用样式
.prepare {
  padding: 20px;
  .bookName {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #9d9292;
  }
  .bookTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 0px;
    color: #000000;
    margin: 10px 0px;
  }
  .photoImg {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .userName {
    font-size: 18px;
    color: #000;
    line-height: 26px;
    margin: 0px 10px;
  }
  .fuhao {
    font-size: 18px;
    color: #9d9292;
    margin-left: 0px;
    line-height: 26px;
  }
  .userSchool {
    font-size: 18px;
    color: #9d9292;
    margin-left: 10px;
    line-height: 26px;
  }
  .questionText {
    font-size: 20px;
    line-height: 30px;
    color: #040506;
  }
  .date {
    color: #9d9292;
    font-size: 14px;
  }
  .forAsk {
    text-align: right;
    height: 30px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 0px;
    color: @primary-color;
    cursor: pointer;
  }
}
.ulList {
  margin-top: 10px;
  .listMes {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #9d9292;
    height: 30px;
    line-height: 30px;
  }
}
.askHelp {
  height: 60px;
  width: 100%;
  background: #fff;
  // padding: 20px 0;
  .ask {
    width: 120px;
    height: 32px;
    background-color: @primary-color;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
    margin-top: 14px;
  }
  .help {
    width: 120px;
    height: 32px;
    background-color: #a3af90;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
    margin-left: 20px;
    margin-top: 14px;
  }
}
.mesMore {
  min-height: 160px;
  overflow-y: auto;
  padding: 20px;
  background: #f6f6f6;
}
.footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
.answerMes {
  .answerText {
    font-size: 16px;
    color: #9d9292;
  }
  .answerName {
    color: @primary-color;
    font-size: 18px;
    margin-left: 20px;
  }
  .answerTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #000000;
    margin-top: 10px;
  }
  .answerBgc {
    margin-top: 10px;
    background-color: #f6f6f6;
  }
  /deep/.ant-input {
    background-color: #f6f6f6;
  }
}
.zjcontent {
  padding: 20px;
  .title {
    height: 50px;
    font-family: PingFangSC-Semibold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #db5647;
    text-align: center;
  }
  .proplem {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0px;
    color: #040506;
    text-align: center;
    .name {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: @primary-color;
    }
  }
  .zjFooter {
    text-align: center;
    margin-top: 10px;
    .cancle {
      width: 160px;
      height: 44px;
      background: #f6f6f6;
      color: #9d9292;
      font-size: 18px;
    }
    .sure {
      width: 160px;
      height: 44px;
      background: #f6f6f6;
      background-color: @primary-color;
      font-size: 18px;
      color: #fff;
      margin-left: 30px;
    }
  }
}
/deep/.ant-modal-header {
  border-bottom: none;
}
/deep/.ant-modal-title {
  font-size: 24px;
  color: #000000;
}
/deep/.ant-list-pagination {
  text-align: center;
  margin-top: 0px;
  background: #fff;
}
/deep/.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}
/deep/.ant-list-split .ant-list-item {
  border-bottom: none;
}
/deep/.ant-list-something-after-last-item
  .ant-spin-container
  > .ant-list-items
  > .ant-list-item:last-child {
  border-bottom: none;
}
/deep/.ant-list-lg .ant-list-item {
  padding: 0px;
}
/deep/.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 0px;
}
/deep/.ant-pagination {
  background: #fff;
  text-align: center;
}
</style>
